export default "__VITE_ASSET__2771880a__"